// Type-only: the store imports this slice's reducer, so a value import of the
// store here would be a runtime circular dependency.
import type { RootState } from '@/store/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// TCX-705: hard cap on how many brands a single Territory Check can target.
export const TERRITORY_CHECK_MAX_BRANDS = 20;

export interface TerritoryCheckBrand {
  id: string;
  company: string;
}

interface TerritoryCheckSlice {
  selected: TerritoryCheckBrand[];
}

const initialState: TerritoryCheckSlice = {
  selected: [],
};

export const territoryCheckSlice = createSlice({
  name: 'territoryCheck',
  initialState,
  reducers: {
    addBrand(state, action: PayloadAction<TerritoryCheckBrand>) {
      const alreadySelected = state.selected.some(
        (brand) => brand.id === action.payload.id,
      );
      if (
        alreadySelected ||
        state.selected.length >= TERRITORY_CHECK_MAX_BRANDS
      ) {
        return;
      }
      state.selected.push(action.payload);
    },
    removeBrand(state, action: PayloadAction<string>) {
      state.selected = state.selected.filter(
        (brand) => brand.id !== action.payload,
      );
    },
    clearBrands(state) {
      state.selected = [];
    },
  },
});

export const { addBrand, removeBrand, clearBrands } =
  territoryCheckSlice.actions;

export const selectTerritoryCheckSelection = (state: RootState) =>
  state.territoryCheck.selected;
// The bar's X clears the selection (same as Clear), so visibility is purely
// "is anything selected".
export const selectTerritoryCheckBarVisible = (state: RootState) =>
  state.territoryCheck.selected.length > 0;

export default territoryCheckSlice.reducer;
